export default "__VITE_ASSET__Yt2XmoqY__"